import { createSlice } from '@reduxjs/toolkit';
import * as _ from 'lodash';
import { MAXIMUM_FIND_PROVIDER_RADIUS } from 'src/constants';
import {
  getNetworksList,
  searchProviders,
  getSearchProviderFilters,
} from './api-calls/findProvider';

const INITIAL_STATE = {
  providerType: null,
  address: '',
  //usercoordinates: {
  //lat: 32.47,
  //lng: -99.7
  //},
  searchProviderParams: {
    pagesize: 10,
    pagenumber: 1,
    Network: null,
    sortby: 'Distance',
    sortdirection: 'asc',
    filters: {
      maximumradius: MAXIMUM_FIND_PROVIDER_RADIUS,
    },
    AcceptingNewPatients: false,
  },
  networksList: [],
  isNetworksListFetched: false,
  isSearchingProviders: false,
  showFilterBar: false,
  filtersValuesList: {},
  searchProviderFiltersChanged: false,
  searchProvidersSortingChanged: false,
  searchResults: { pagination: null, data: null },
  noResultsFound: false,
  showServerError: false,
};

export const findProviderSlice = createSlice({
  name: 'findProvider',
  initialState: INITIAL_STATE,
  reducers: {
    setProviderType: (state, action) => {
      state.providerType = action.payload;
      state.searchProviderParams = INITIAL_STATE.searchProviderParams;
      state.searchResults = INITIAL_STATE.searchResults;
      state.showFilterBar = INITIAL_STATE.showFilterBar;
    },
    setAddress: (state, action) => {
      state.address = action.payload;
      if (action.payload.length < 3) {
        state.providerType = null;
        state.searchProviderParams = { ...INITIAL_STATE.searchProviderParams };
        state.searchResults = { ...INITIAL_STATE.searchResults };
      }
    },
    setSearchProviderParams: (state, action) => {
      state.searchProviderParams = {
        ...state.searchProviderParams,
        ...action.payload,
      };
    },
    setSearchProviderSorting: (state, action) => {
      state.searchProviderParams.sortby = action.payload.sortby;
      state.searchProviderParams.sortdirection = action.payload.sortdirection;
      state.searchProvidersSortingChanged = true;
    },
    setSearchProviderFilters: (state, action) => {
      state.searchProviderParams.filters = {
        ...state.searchProviderParams.filters,
        ...action.payload,
      };
      state.searchProviderFiltersChanged = true;
    },
    setFilterChangeStatus: (state, action) => {
      state.searchProviderFiltersChanged = action.payload || false;
    },
    resetSortingChangeStatus: (state, action) => {
      state.searchProvidersSortingChanged = action.payload || false;
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    resetSearchParams: (state, action) => {
      Object.keys(INITIAL_STATE).forEach((key) => {
        if (key !== 'networksList') {
          state[key] = INITIAL_STATE[key] || null;
        }
      });
    },
    resetSearchProviderFilters: (state, action) => {
      state.searchProviderParams.filters =
        INITIAL_STATE.searchProviderParams.filters;
      state.searchProviderParams.AcceptingNewPatients = false;
      state.searchProviderParams.sortby = 'Distance';
      state.searchProviderParams.sortdirection = 'asc';
      state.searchProviderParams.pagesize = 10;
      state.searchProviderParams.pagenumber = 1;
      state.searchProviderFiltersChanged = true;
    },
    searchProviderFiltersInitial: (state, action) => {
      state.searchProviderParams.filters =
        INITIAL_STATE.searchProviderParams.filters;
      state.searchProviderFiltersChanged = false;
    },
    resetNetworkList: (state, action) => {
      state.networksList = INITIAL_STATE.networksList;
    },
    resetSearchResults: (state, action) => {
      state.searchResults = INITIAL_STATE.searchResults;
    },
    setNetworkTierListFinal: (state, action) => {
      state.finalNetworkTierList = action.payload;
    },
  },
  extraReducers: {
    [getNetworksList.fulfilled]: (state, action) => {
      state.networksList =
        action.payload.data.Response.PriceCompareNetworkTeirInfo;

      state.isNetworksListFetched = true;
    },
    [searchProviders.pending]: (state, action) => {
      //state.isSearchingProviders = state.searchProviderParams?.selectedNetwork?.ProviderDirectory === 'R'? false: true;
      state.isSearchingProviders = true;
      state.showFilterBar = false;
      state.noResultsFound = false;
      state.showServerError = false;
      state.searchResults = { pagination: null, data: null };
    },
    [searchProviders.fulfilled]: (state, action) => {
      const response = action.payload.data.Response;
      if (response?.Pagination?.PageNumber >= 0) {
        response.Pagination.PageNumber += 1;
      }
      state.searchResults = {
        pagination: response?.Pagination,
        data: response?.data,
      };
      state.isSearchingProviders = false;

      //only for testing starts

      //if (response.data?.length > 0) {
      //state.orgData = response.data;
      //}
      //if (!response.data?.length) {
      //response.data = [...state.orgData];
      //}

      //state.searchResults = { pagination: { ...response.Pagination, TotalRecords: 10 }, data: response.data };
      //only for testing ends

      if (
        _.isEqual(
          state.searchProviderParams.filters,
          INITIAL_STATE.searchProviderParams.filters,
        )
      ) {
        state.showFilterBar = response?.data?.length > 0 ? true : false;
      } else {
        state.showFilterBar = true;
      }
      state.noResultsFound = response?.data?.length > 0 ? false : true;
    },
    [searchProviders.rejected]: (state, action) => {
      console.log('********** error', action.error);
      const response = action.error.message.split(
        'Request failed with status code ',
      );
      if (response[1] === '404') {
        state.showServerError = false;
        state.noResultsFound = true;

        state.showFilterBar = false;
        state.isSearchingProviders = false;
        state.searchResults = [];
      } else {
        state.showFilterBar = false;
        state.isSearchingProviders = false;
        state.searchResults = [];
        state.showServerError = true;
      }
    },
    [getSearchProviderFilters.pending]: (state, action) => {},
    [getSearchProviderFilters.fulfilled]: (state, action) => {
      if (action.payload && action.payload.data) {
        const resp = action.payload.data.Response;
        Object.keys(resp).forEach((key) => {
          if (
            [
              'UniqueLanguages',
              'UniqueSpecialities',
              'ProviderServices',
            ].includes(key)
          ) {
            resp[key] = resp[key].map((ele) => {
              return { label: ele, value: ele };
            });
          }
        });
        state.filtersValuesList = resp;
      }
    },
    [getSearchProviderFilters.rejected]: (state, action) => {
      state.filtersValuesList = {};
    },
  },
});

export const {
  setSearchProviderParams,
  setAddress,
  setProviderType,
  setSearchResults,
  setSearchProviderFilters,
  resetSearchParams,
  setFilterChangeStatus,
  resetSearchProviderFilters,
  setSearchProviderSorting,
  resetSortingChangeStatus,
  resetNetworkList,
  resetSearchResults,
  searchProviderFiltersInitial,
  setNetworkTierListFinal,
} = findProviderSlice.actions;

export default findProviderSlice.reducer;
